import React from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, RichUtils,Modifier } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./NoteTextEditor.css";
import "../../App.css";

const NoteTextEditor = ({ editorState, setEditorState }) => {
  const onEditorStateChange = (newState) => {
    setEditorState(newState);
  };

  const handleReturn = (e) => {
    const content = editorState.getCurrentContent();
    const selection = editorState.getSelection();

    // Eğer seçili metin varsa, Draft.js default davranışını kullan
    if (!selection.isCollapsed()) {
      return 'not-handled';
    }

    // Bulunduğun blok tipi
    const blockKey = selection.getStartKey();
    const block = content.getBlockForKey(blockKey);
    const type = block.getType();

    // List-item içindeysek yine Draft.js’e bırakıyoruz
    if (type === 'unordered-list-item' || type === 'ordered-list-item') {
      return 'not-handled';
    }

    // Diğer tüm bloklarda soft newline (satır içi <br>) ekle
    const newState = RichUtils.insertSoftNewline(editorState);
    setEditorState(newState);
    return 'handled';
  };

  const handlePastedText = (text, html, state) => {
    const cleaned = text.replace(/(\r?\n){2,}/g, '\n');
    const selection = state.getSelection();
    const content = state.getCurrentContent();

    const newContent = selection.isCollapsed()
      ? Modifier.insertText(content, selection, cleaned)
      : Modifier.replaceText(content, selection, cleaned);

    setEditorState(EditorState.push(state, newContent, 'insert-characters'));
    return 'handled';
  };

  return (
    <div className="editor-container" style={{ maxWidth: '100%', overflowY: 'auto', height: '90%' }}>
      <Editor
        editorState={editorState}
        onEditorStateChange={onEditorStateChange}
        handleReturn={handleReturn}
        handlePastedText={handlePastedText}
        toolbar={{
          options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'link', 'history', 'remove'],
          inline: { options: ['bold', 'italic', 'underline', 'strikethrough'] },
          blockType: { inDropdown: true },
          fontSize: { options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 36] },
          fontFamily: { options: ['Arial', 'Georgia', 'Times New Roman', 'Verdana'] },
        }}
        toolbarClassName="toolbar"
        wrapperClassName="wrapper"
        editorClassName="editor"
      />
    </div>
  );
};

export default NoteTextEditor;